<ng-template #content let-c="close" let-d="dismiss">
  <div class="lna-modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      {{ 'components.deleteClassifierItem.title' | translate: { name: value.name } }}
    </h4>
    <button class="btn-close" (click)="d('Cross click')" type="button" aria-label="Close"></button>
  </div>
  <div class="lna-modal-body">
    @if (isLoading) {
      <div class="lna-spinner">
        <app-spinner [isLoading]="isLoading"></app-spinner>
      </div>
    }
  </div>
  <div class="lna-modal-footer">
    <button class="primary" (click)="handleSave()" type="button">
      {{ 'components.deleteClassifierItem.save' | translate }}
    </button>
    <button class="secondary" (click)="d('Cross click')" type="button">
      {{ 'components.deleteClassifierItem.cancel' | translate }}
    </button>
  </div>
</ng-template>

<button class="open-button" (click)="open(content)">
  <img src="assets/images/delete-icon.svg" alt="delete" />
  {{ 'components.deleteClassifierItem.remove' | translate }}
</button>
